export { default } from "./FAQsItem"
